import { trans, TranslationOptions } from "@dx/i18n";

const lang = "en-GB";
const namespace = "b2b-nova-fe";

/**
 * Provides the $t translation function early in the plugin chain,
 * so it's available even if later plugins (auth, initial-data) fail.
 */
export default defineNuxtPlugin(() => {
  return {
    provide: {
      t: (id: string, options?: TranslationOptions) => trans(lang, namespace, id, options),
    },
  };
});
